'use strict';

var _slicedToArray = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var multiaddr = require('multiaddr');

var env_js = require('ipfs-utils/src/env.js');

var parseDuration = require('parse-duration');

var debug = require('debug');

var HTTP = require('ipfs-utils/src/http.js');

var mergeOpts = require('merge-options');

var toUrlString = require('ipfs-core-utils/to-url-string');

var getAgent = require('ipfs-core-utils/agent');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var parseDuration__default =
/*#__PURE__*/
_interopDefaultLegacy(parseDuration);

var debug__default =
/*#__PURE__*/
_interopDefaultLegacy(debug);

var HTTP__default =
/*#__PURE__*/
_interopDefaultLegacy(HTTP);

var mergeOpts__default =
/*#__PURE__*/
_interopDefaultLegacy(mergeOpts);

var getAgent__default =
/*#__PURE__*/
_interopDefaultLegacy(getAgent);

var log = debug__default["default"]('ipfs-http-client:lib:error-handler');
var merge = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var DEFAULT_PROTOCOL = env_js.isBrowser || env_js.isWebWorker ? location.protocol : 'http';
var DEFAULT_HOST = env_js.isBrowser || env_js.isWebWorker ? location.hostname : 'localhost';
var DEFAULT_PORT = env_js.isBrowser || env_js.isWebWorker ? location.port : '5001';

var normalizeOptions = function normalizeOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url;
  var opts = {};
  var agent;

  if (typeof options === 'string' || multiaddr.Multiaddr.isMultiaddr(options)) {
    url = new URL(toUrlString.toUrlString(options));
  } else if (options instanceof URL) {
    url = options;
  } else if (typeof options.url === 'string' || multiaddr.Multiaddr.isMultiaddr(options.url)) {
    url = new URL(toUrlString.toUrlString(options.url));
    opts = options;
  } else if (options.url instanceof URL) {
    url = options.url;
    opts = options;
  } else {
    opts = options || {};
    var protocol = (opts.protocol || DEFAULT_PROTOCOL).replace(':', '');
    var host = (opts.host || DEFAULT_HOST).split(':')[0];
    var port = opts.port || DEFAULT_PORT;
    url = new URL("".concat(protocol, "://").concat(host, ":").concat(port));
  }

  if (opts.apiPath) {
    url.pathname = opts.apiPath;
  } else if (url.pathname === '/' || url.pathname === undefined) {
    url.pathname = 'api/v0';
  }

  if (env_js.isNode) {
    var Agent = getAgent__default["default"](url);
    agent = opts.agent || new Agent({
      keepAlive: true,
      maxSockets: 6
    });
  }

  return _objectSpread({}, opts, {
    host: url.host,
    protocol: url.protocol.replace(':', ''),
    port: Number(url.port),
    apiPath: url.pathname,
    url: url,
    agent: agent
  });
};

var errorHandler =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(response) {
    var msg, data, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(response.headers.get('Content-Type') || '').startsWith('application/json')) {
              _context.next = 9;
              break;
            }

            _context.next = 4;
            return response.json();

          case 4:
            data = _context.sent;
            log(data);
            msg = data.Message || data.message;
            _context.next = 12;
            break;

          case 9:
            _context.next = 11;
            return response.text();

          case 11:
            msg = _context.sent;

          case 12:
            _context.next = 18;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            log('Failed to parse error response', _context.t0);
            msg = _context.t0.message;

          case 18:
            error = new HTTP__default["default"].HTTPError(response);

            if (msg) {
              if (msg.includes('deadline has elapsed')) {
                error = new HTTP__default["default"].TimeoutError();
              }

              if (msg && msg.includes('context deadline exceeded')) {
                error = new HTTP__default["default"].TimeoutError();
              }
            }

            if (msg && msg.includes('request timed out')) {
              error = new HTTP__default["default"].TimeoutError();
            }

            if (msg) {
              error.message = msg;
            }

            throw error;

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));

  return function errorHandler(_x) {
    return _ref.apply(this, arguments);
  };
}();

var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;

var kebabCase = function kebabCase(str) {
  return str.replace(KEBAB_REGEX, function (match) {
    return '-' + match.toLowerCase();
  });
};

var parseTimeout = function parseTimeout(value) {
  return typeof value === 'string' ? parseDuration__default["default"](value) : value;
};

var Client =
/*#__PURE__*/
function (_HTTP__default$defaul) {
  _inherits(Client, _HTTP__default$defaul);

  function Client() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Client);

    var opts = normalizeOptions(options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Client).call(this, {
      timeout: parseTimeout(opts.timeout || 0) || undefined,
      headers: opts.headers,
      base: "".concat(opts.url),
      handleError: errorHandler,
      transformSearchParams: function transformSearchParams(search) {
        var out = new URLSearchParams();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = search[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref4 = _step.value;

            var _ref3 = _slicedToArray(_ref4, 2);

            var key = _ref3[0];
            var value = _ref3[1];

            if (value !== 'undefined' && value !== 'null' && key !== 'signal') {
              out.append(kebabCase(key), value);
            }

            if (key === 'timeout' && !isNaN(value)) {
              out.append(kebabCase(key), value);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return out;
      },
      agent: opts.agent
    }));
    delete _this.get;
    delete _this.put;
    delete _this.delete;
    delete _this.options;
    var fetch = _this.fetch;

    _this.fetch = function (resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof resource === 'string' && !resource.startsWith('/')) {
        resource = "".concat(opts.url, "/").concat(resource);
      }

      return fetch.call(_assertThisInitialized(_this), resource, merge(options, {
        method: 'POST'
      }));
    };

    return _this;
  }

  return Client;
}(HTTP__default["default"]);

var HTTPError = HTTP__default["default"].HTTPError;
exports.Client = Client;
exports.HTTPError = HTTPError;
exports.errorHandler = errorHandler;